import FeaturedCard from "@/components/FeaturedCard";
import { apiUrl } from "@/constants";
import { Songcard } from "@/types";
import { typedFetch } from "@/utils/resultFetch";
import {
  Center,
  Container,
  Heading,
  Input,
  SimpleGrid,
  Spinner,
  useColorMode,
} from "@chakra-ui/react";
import Head from "next/head";
import Image from "next/image";
import Link from "next/link";
import { useEffect, useState } from "react";
import { useCallback } from "react";

export default function Search() {
  const [searchTerm, setSearchTerm] = useState("");
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState("");
  const [searchResults, setSearchResults] = useState<Songcard[]>([]);
  const [loading, setLoading] = useState(false);
  const { colorMode } = useColorMode();

  const getResults = useCallback(async () => {
    setLoading(true);
    const url = `${apiUrl}/ninja/search-cards?search=` + debouncedSearchTerm;
    const result = await typedFetch(url);

    await result.match(
      async (res) => {
        const json = await res.json();
        setSearchResults(json);
      },
      (err) => {
        console.error("Fetch error:", err.message);
      },
    );

    setLoading(false);
  }, [debouncedSearchTerm]);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearchTerm(searchTerm);
    }, 500);

    return () => {
      clearTimeout(handler);
    };
  }, [searchTerm]);

  useEffect(() => {
    if (debouncedSearchTerm) {
      getResults();
    }
  }, [debouncedSearchTerm, getResults]);

  return (
    <>
      <Head>
        <title>Songcards - Search</title>
        <meta
          name="description"
          content="Search songcards by artist, song, or genre."
        />
        <link rel="icon" href="/songcards.png" />
        <meta property="og:title" content="Songcards - Search" key="title" />
        <meta
          property="og:description"
          content="Search songcards by artist, song, or genre."
          key="description"
        />
      </Head>
      <Container>
        <Heading ml={1}>Search</Heading>
        <br />
      </Container>
      <Center>
        <Input
          type="text"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          placeholder="Search by artist, song, or genre..."
          colorScheme="pink"
          variant={"outline"}
          focusBorderColor="rgba(255,153,213,0.9)"
          maxW={"lg"}
          ml={5}
          mr={5}
        />
      </Center>
      <br />
      {loading && (
        <Center mt={10}>
          <Spinner size="xl" color="rgba(255,153,213,0.9)" />
        </Center>
      )}
      <Container mb={1000} maxW="2xl" p={4} overflowY={"auto"}>
        <SimpleGrid columns={[1, null, 2]} spacing="25px">
          {searchResults.map((card, index) => (
            <FeaturedCard embed={false} card={card} key={index} />
          ))}
        </SimpleGrid>
        {searchResults.length > 0 && (
          <Center mt={100}>
            <Link href={`/`}>
              <Image
                src={
                  colorMode === "dark"
                    ? "/SC Icon_B_White.svg"
                    : "/SC Icon_B_Black.svg"
                }
                width={30}
                alt="Discover more Songcards"
                height={30}
              />
            </Link>
          </Center>
        )}
      </Container>
    </>
  );
}
